import { inject, Injectable } from '@angular/core';
import { AsappChatService } from './asapp-chat.service';
import { AsappChatConfig, AsappCustomerInfo } from '../../model/asapp-chat/asapp-chat.dto';
import { CryptoService } from './cypto/crypto.service';
import { PGHOktaService } from './pghokta.service';
import { GoogleAnalyticsService } from './google-tag-manager.service';

/**
 * Service to initialize ASAPP Chat in the app component
 */
@Injectable({
  providedIn: 'root',
})

export class AsappChatInitializer {
  private asappChatService = inject(AsappChatService);
  private cryptoService = inject(CryptoService);
  private pghOktaService = inject(PGHOktaService);
  private googleAnalyticsService = inject(GoogleAnalyticsService);

  /**
   * Initializes ASAPP Chat with configuration from window object
   */
  initialize(customerInfo: AsappCustomerInfo): void {
    // Check if ASAPP Chat is enabled and configuration is available
    if (this.asappChatService.isShow && !this.asappChatService.isInitialized) {
      const asappConfig = window.config.Asapp as AsappChatConfig;

      // Load ASAPP Chat service with configuration
      this.asappChatService.load(asappConfig, this.cryptoService, this.pghOktaService, this.googleAnalyticsService);
      this.asappChatService.setCustomerDetail(customerInfo);


      console.log('ASAPP Chat initialized');
    } else if (!this.asappChatService.isShow && !this.asappChatService.isInitialized) {
      // ASAPP Chat is disabled or configuration is missing
    }
  }
}
